import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, adminToken } from "@/lib/api";
import SEO from "@/components/SEO";

const LOGO_URL =
  "/brand/wet-cabbage-skegness-light.jpg";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      adminToken.set(r.data.token);
      toast.success("Welcome back, curator.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-[70vh] items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <SEO title="Admin Login" path="/admin/login" noindex />
      <img
        src={LOGO_URL}
        alt=""
        className="pointer-events-none absolute -top-6 -right-6 h-72 w-72 object-contain mix-blend-multiply wc-wobble opacity-90"
      />
      <form
        onSubmit={submit}
        className="relative z-10 w-full max-w-md border-2 border-[#1A3626] bg-[#F9F9F4] p-8"
        data-testid="admin-login-form"
      >
        <div className="font-display text-xs font-bold uppercase tracking-[0.3em]">
          Administrator · signage required
        </div>
        <h1 className="font-display mt-3 text-4xl font-black tracking-tighter">
          Curator login.
        </h1>
        <p className="mt-3 text-sm">
          For the mildly qualified. Submissions await your judgement.
        </p>
        <div className="mt-6 space-y-4">
          <div>
            <label className="font-display mb-2 block text-xs font-bold uppercase tracking-[0.3em]">
              Email
            </label>
            <input
              type="email"
              className="wc-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="font-display mb-2 block text-xs font-bold uppercase tracking-[0.3em]">
              Password
            </label>
            <input
              type="password"
              className="wc-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="wc-btn w-full"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in..." : "Enter the vault"}
          </button>
        </div>
      </form>
    </div>
  );
}
